<div class="modal-header">
  <h5 class="modal-title">
    Remito {{ remito?.prefijo }}-{{ remito?.numeroRemito }}
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cerrar()"></button>
</div>

<div class="modal-body">
  <div class="mb-3">
    <strong>Aeroplanta:</strong> {{ remito?.codigoAeroplanta }} |
    <strong>Terminal:</strong> {{ remito?.codigoTerminal }}
  </div>

  <div class="table-responsive">
    <table class="table table-sm table-striped text-center align-middle">
      <thead>
        <tr>
          <th>Código</th>
          <th>Producto</th>
          <th>Volumen natural</th>
          <th>Volumen 15 °C</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let p of remito?.detalleProductos">
          <td>{{ p.codigoProducto }}</td>
          <td>{{ p.nombreProducto }}</td>
          <td>{{ totalNatural(p) | number: '1.0-3' }}</td>
          <td>{{ total15(p) | number: '1.0-3' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-outline-secondary" (click)="cerrar()">Cerrar</button>
</div>
